import { channelVideoListValues } from 'default-settings';

export function isExpandOnClick(status) {
  return status === channelVideoListValues.EXPAND_ON_CLICK;
}

export function isAlwaysShow(status) {
  return status === channelVideoListValues.ALWAYS_SHOW;
}

export function isNeverShow(status) {
  return Number(status) === channelVideoListValues.NEVER_SHOW;
}



// WEBPACK FOOTER //
// ./src/widget/utils/video-list.js